import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import CommentIcon from '@mui/icons-material/Comment';
import LinkIcon from '@mui/icons-material/Link';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const NOTIFICATIONS = [
    {
        badgeLabel: 'New User',
        badgeClass: 'badge-new',
        icon: PersonAddAlt1Icon,
        accent: 'pink',
        title: 'New Registration: Finibus Bonorum et Malorum',
        description: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium',
        name: 'Allen Deu',
        time: '24 Nov 2018 at 9:30 AM',
    },
    {
        badgeLabel: 'Message',
        badgeClass: 'badge-msg',
        icon: ChatBubbleIcon,
        accent: 'pink',
        title: 'Darren Smith sent new message',
        description: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium',
        name: 'Darren',
        time: '24 Nov 2018 at 9:30 AM',
    },
    {
        badgeLabel: 'Comment',
        badgeClass: 'badge-comment',
        icon: CommentIcon,
        accent: 'purple',
        title: 'Arin Ganshiram Commented on post',
        description: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium',
        name: 'Arin Ganshiram',
        time: '24 Nov 2018 at 9:30 AM',
    },
    {
        badgeLabel: 'Connect',
        badgeClass: 'badge-connect',
        icon: LinkIcon,
        accent: 'blue',
        title: 'Jullet Den Connect Allen Depk',
        description: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium',
        name: 'Jullet Den',
        time: '24 Nov 2018 at 9:30 AM',
    },
    {
        badgeLabel: 'Message',
        badgeClass: 'badge-msg',
        icon: ChatBubbleIcon,
        accent: 'pink',
        title: 'Darren Smith sent new message',
        description: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium',
        name: 'Jullet Den',
        time: '24 Nov 2018 at 9:30 AM',
    },
];

const Notification = () => {
    const navigator = useNavigate();
    return (
        <>
            <Helmet>
                <title>Notifications | TLK</title>
            </Helmet>
            {/* start: notifications page */}
            <div className="notif-page">
                <header className="notif-header">
                    <div className="notif-header-left">
                        <button className="notif-back-btn" onClick={() => navigator(-1)}>
                            <ArrowBackIcon fontSize="small" />
                        </button>
                        <div className="notif-title">
                            <span className="notif-bar"></span>
                            <h1>Notifications</h1>
                        </div>
                    </div>
                    <button className="notif-mark-read">Mark all as read</button>
                </header>

                <main className="notif-main">
                    <div className="notif-card">
                        <div className="notif-list">
                            {NOTIFICATIONS.map((item, index) => {
                                const Icon = item.icon;
                                return (
                                    <div className="notif-item" key={index}>
                                        <div className={`notif-item-icon accent-${item.accent}`}>
                                            <Icon fontSize="small" />
                                        </div>
                                        <div className="notif-item-body">
                                            <div className="notif-item-top">
                                                <div className="notif-item-heading">
                                                    <span className={`notif-badge ${item.badgeClass}`}>{item.badgeLabel}</span>
                                                    <h3>{item.title}</h3>
                                                </div>
                                                <span className="notif-item-time">{item.time}</span>
                                            </div>
                                            <p className="notif-item-desc">{item.description}</p>
                                            <span className="notif-item-name">{item.name}</span>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        <div className="notif-load-more">
                            <button>Load Older Notifications</button>
                        </div>
                    </div>
                </main>
            </div>
            {/* end: notifications page */}
        </>
    );
}

export default Notification;